import { render, staticRenderFns } from "./fireFightingJournalDetail.vue?vue&type=template&id=ace874c4"
import script from "./fireFightingJournalDetail.vue?vue&type=script&lang=js"
export * from "./fireFightingJournalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ace874c4')) {
      api.createRecord('ace874c4', component.options)
    } else {
      api.reload('ace874c4', component.options)
    }
    module.hot.accept("./fireFightingJournalDetail.vue?vue&type=template&id=ace874c4", function () {
      api.rerender('ace874c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/fft/journal/fireFightingJournalDetail.vue"
export default component.exports